import { render, staticRenderFns } from "./MandateTransactions.vue?vue&type=template&id=0c98eb9e&scoped=true&"
import script from "./MandateTransactions.vue?vue&type=script&lang=js&"
export * from "./MandateTransactions.vue?vue&type=script&lang=js&"
import style0 from "./MandateTransactions.vue?vue&type=style&index=0&id=0c98eb9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c98eb9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c98eb9e')) {
      api.createRecord('0c98eb9e', component.options)
    } else {
      api.reload('0c98eb9e', component.options)
    }
    module.hot.accept("./MandateTransactions.vue?vue&type=template&id=0c98eb9e&scoped=true&", function () {
      api.rerender('0c98eb9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/MandateTransactions.vue"
export default component.exports